import { FormFields, AirtableFields } from 'components';


const Fields = {
  ...AirtableFields,
  ...FormFields,
};

export const getFieldComponent = (type) => {
  return  Fields[type] ?? Fields['unknown'];
};
